<ng-template #tableTemplate>
    <n-data-table id="delete-homedir-rule-cifs-share-table"
        style="height: 2rem;"
        [columnDefs]="tableColumnDefs"
        [data]="dataList">
    </n-data-table>
</ng-template>

